(function () {
  const body = document.body;
  const card = document.getElementById("sticky-cta-card");
  const footer = document.getElementById("main-footer");
  let isVisibleMemo = false;
  if (!card || !footer) return;

  const isFooterVisible = () => {
    const footerRect = footer.getBoundingClientRect();
    return footerRect.top <= window.innerHeight && footerRect.bottom >= 0;
  };

  window.addEventListener("scroll", () => {
    const scrollLimit = window.innerHeight;
    const isVisible = window.scrollY > scrollLimit && !isFooterVisible();

    if (isVisible === isVisibleMemo) return;

    isVisibleMemo = isVisible;
    card.dataset.animate = true;

    card.addEventListener(
      "transitionend",
      (e) => {
        if (e.target !== card) return;
        card.dataset.animate = false;
      },
      { once: true }
    );

    if (isVisible) {
      card.dataset.hidden = false;
      cardVisible = true;
      body.classList.add("sticky-cta-visible");
      return;
    }

    card.dataset.hidden = true;
    cardVisible = false;
    body.classList.remove("sticky-cta-visible");
  });
})();
